/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}toast`;
const observedAttributes = {
    OPEN: 'open',
    DURATION: 'duration',
    PLACEMENT: 'placement',
    ACTION_TEXT: 'action-text',
    DISMISSIBLE: 'dismissible',
    DISMISS_LABEL: 'dismiss-label',
    THEME: 'theme'
};
const attributes = {
    ...observedAttributes
};
const events = {
    ACTION: `${elementName}-action`,
    CLOSE: `${elementName}-close`
};
const classes = {
    EXITING: 'exiting'
};
const selectors = {
    SURFACE: '.surface',
    ACTION_BUTTON: '.action-button',
    CLOSE_BUTTON: '.close-button'
};
const defaults = {
    PLACEMENT: 'bottom',
    DURATION: 2750,
    THEME: 'default'
};
export const TOAST_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    classes,
    selectors,
    defaults,
    events
};
